export default function convertMilesToKm(value) {
    return Math.round(value / 0.621371);
}
